// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
export const APP_NAME = 'webtool';

// export const DOMAIN = 'https://sms-gui.vedtechlabs.in';
// export const DOMAIN = 'https://backend66.gmstool.com/';
export const DOMAIN = 'https://bridzobackend.bridzo.com';
// export const DOMAIN = 'http://89.167.45.231:8081';
// export const DOMAIN = 'https://uatbackend1.gmstool.com';
// export const DOMAIN = 'https://backend1.hrms4all.com';
// export const DOMAIN = 'https://backend1.ncrvolcano.in';s
export const BASE_URL = `${DOMAIN}`;

export const NUMERIC_REGEX = /^-?(0|[1-9][0-9]*)(\.[0-9]*)?$/;
export const SENDER_ID_REGEX = /^(?=.*[a-zA-Z0-9])(?!^\d+$)[a-ziA-Z0-9]{6,6}$/;
export const NUMERIC_6_REGEX = /^[0-9]+$/;
export const PLAIN_TXT_REGEX = /^[-;'\"<>?A-Za-z0-9_…~!:\/.@\\|\\,#\\$%\\^&\\*\\(\\)\n\s +=\\\\{}\\[\]]*$/;
// export const PLAIN_TXT_REGEX = ("^[A-Za-z0-9_~\\-!:\\/.@\\|\\,#\\$%\\^&\\*\\(\\)\n\s\r +=\\\\{}\\'\"<>?]*$");
export const NUMBER_REGEX = /^-?(0|[1-9][0-9]*)(\.[0-9]*)?$/;
export const SAMPLE_DYNAMIC_DOWNLOAD = `${DOMAIN}/files/Dynamic_campaign_sample_file.xlsx`
export const CAMPAIGN_NAME_REGEX = '[a-zA-Z0-9_-]+';
export const CAMPAIGN_NAME_HINT = "Special characters are not allowed in campaign name like SPACE , [ ] @ $ % & ^ * ~ { } | \ ; : " + '"' + " ' <> . ? / ~ ` ";

export const environment = {
  production: false,
  switchUser: `${BASE_URL}/auth/api/switch-user`,
  // loginUrl: `${BASE_URL}/reseller/loginUserNameEmail`,
  // loginUrl: `${BASE_URL}/auth/api/login`,
  loginUrl: `${BASE_URL}/auth/api/loginByUserName`,
  Url: `${BASE_URL}/reseller/loginUserByEmailWeb`,
  verifyOTP: `${BASE_URL}/reseller/verfityOtpLoginUserNameEmail`,

  // Dashboard
  dashboardCards: `${BASE_URL}/sms/sms-reseller-service/wt/mis/dashboard`,
  summaryReport: `${BASE_URL}/sms/sms-reseller-service/wt/reportService/summaryReport`,
  senderIDReport: `${BASE_URL}/sms/sms-reseller-service/wt/reportService/senderIdWiseReport`,
  detailedReport: `${BASE_URL}/sms/sms-reseller-service/wt/reportService/detailedReport`,
  detailedReportData: `${BASE_URL}/sms/sms-reseller-service/wt/reportService/detailedReportData`,
  getAllCampaignName:`${BASE_URL}/sms/sms-reseller-service/wt/campaignService/getAllCampaignName`,
  getHourlySummaryReport: `${BASE_URL}/sms/sms-reseller-service/wt/reportService/getHourlySummaryReport`,
  telcoReport: `${BASE_URL}/sms/sms-reseller-service/wt/reportService/detailedReport`,

  // Donload Report
  campaignReport: `${BASE_URL}/sms/sms-reseller-service/wt/reportService/campaignReport`,
  viewGeneratedReport: `${BASE_URL}/sms/sms-reseller-service/wt/mis/viewGeneratedReports`,
  generateReport: `${BASE_URL}/sms/sms-reseller-service/wt/mis/generateReport`,

  // Credit History
  creditHistory: `${BASE_URL}/sms/sms-reseller-service/wt/creditService/getCreditHistory`,
  allSenderIdList: `${BASE_URL}/sms/sms-reseller-service/wt/senderIdService/viewAllSenderIdList`,

  // Content Template
  viewAllContentTemplates: `${BASE_URL}/sms/sms-reseller-service/wt/contentTemplateService/viewAllContentTemplateList`,
  getSenderIds: `${BASE_URL}/sms/sms-reseller-service/wt/senderIdService/viewSenderIdListByMessageType`,
  saveContentTemplate: `${BASE_URL}/sms/sms-reseller-service/wt/contentTemplateService/saveContentTemplate`,
  uploadDltDataFile: `${BASE_URL}/sms/sms-reseller-service/wt/uploadDltDataFile`,
  uploadCustomFile: `${BASE_URL}/sms/sms-reseller-service/wt/uploadCustomDltDataFile`,
  addSenderId: `${DOMAIN}/sms/sms-reseller-service/wt/senderIdService/addSenderId`,

  // Phonebook / Blacklist
  // getAllGroups : `${BASE_URL}/groupService/getAllGroupsList`,
  getAllPhoneBookGroup: `${DOMAIN}/sms/sms-reseller-service/groupService/getAllGroupsList`,
  addPhoneBookGroup: `${DOMAIN}/sms/sms-reseller-service/groupService/addGroup`,
  deletePhoneBookGroup: `${DOMAIN}/sms/sms-reseller-service/wt/groupService/deleteGroup`,
  listContacts: `${DOMAIN}/sms/sms-reseller-service/groupNumberDetailsService/getAllNumbersInGroup`,
  searchGroupNumber: `${DOMAIN}/sms/sms-reseller-service/groupNumberDetailsService/searchNumber`,
  removeNumberFromGroup: `${DOMAIN}/sms/sms-reseller-service/wt/groupNumberDetailsService/removeNumberFromGroup`,
  addNewContacts: `${DOMAIN}/sms/sms-reseller-service/groupNumberDetailsService/addNumberToGroup`,
  uploadNumberInUserGroup: `${BASE_URL}/sms/sms-reseller-service/groupService/uploadNumberInUserGroup`,
  getAllBlacklistNumbersForUser: `${BASE_URL}/sms/sms-reseller-service/userBlackListService/getAllBlacklistNumbersForUser`,
  removeNumberFromUserBlackList: `${DOMAIN}/sms/sms-reseller-service/userBlackListService/removeNumberFromUserBlackList`,
  addNumberToBlackList: `${BASE_URL}/sms/sms-reseller-service/userBlackListService/addNumberInUserBlackList`,
  uploadBlackList: `${BASE_URL}/sms/sms-reseller-service/wt/userBlackListService/uploadUserBlackListNumberFile`,

  deleteSenderId: `${BASE_URL}/sms/sms-reseller-service/wt/senderIdService/deleteSenderId`,
  deleteTemplate: `${DOMAIN}/sms/sms-reseller-service/wt/contentTemplateService/deleteContentTemplate`,
  searchContentTemplate: `${BASE_URL}/sms/sms-reseller-service/wt/contentTemplateService/searchContentTemplate`,
  operatorTemplateId: `${BASE_URL}/sms/sms-reseller-service/wt/contentTemplateService/searchContentTemplate`,
  templateTitle: `${BASE_URL}/sms/sms-reseller-service/wt/contentTemplateService/searchContentTemplate`,
  // Webtool
  detailedAnalyticsReport: `${DOMAIN}/sms/sms-reseller-service/wt/reportService/detailedAnalyticsReport`,
  activeHostName: `${DOMAIN}/sms/sms-reseller-service/shortUrlService/getAllActiveAndApprovedHostNameForUser`,
  addShortUrl: `${DOMAIN}/sms/sms-reseller-service/wt/shortUrlService/addShortUrl`,
  viewAllShortUrl: `${DOMAIN}/sms/sms-reseller-service/shortUrlService/viewAllActiveShortUrlForUser`,
  deleteShortUrl: `${DOMAIN}/sms/sms-reseller-service/wt/shortUrlService/deleteShortUrl`,
  listAlApprovedDomains: `${DOMAIN}/sms/sms-reseller-service/shortUrlService/viewAllActiveHostNameForUser`,
  deleteHostName: `${BASE_URL}/sms/sms-reseller-service/wt/shortUrlService/deleteHostName`,
  addDomainName: `${BASE_URL}/sms/sms-reseller-service/shortUrlService/addHostName`,
  getCampaignReport: `${DOMAIN}/sms/sms-reseller-service/campaignService/viewConsolidateScheduledCampaignForUser`,
  deletescheduleCampaignReport: `${DOMAIN}/sms/sms-reseller-service/wt/campaignService/deleteConsolidateScheduledCampaignForUser`,
  // Campaign
  viewContentTemplate: `${DOMAIN}/sms/sms-reseller-service/wt/contentTemplateService/viewAllContentTemplateListByMessageType`,
  sendQuickSMS: `${DOMAIN}/sms/sms-reseller-service/sendSMSService/sendQuickSMS`,
  uploadFile: `${DOMAIN}/sms/sms-reseller-service/uploadFile`,
  uploadCampaign: `${DOMAIN}/sms/sms-reseller-service/scheduleFile`,
  templateIDReport: `${BASE_URL}/sms/sms-reseller-service/wt/reportService/templateIdWiseReport`,
  uploadDynamicFile: `${DOMAIN}/sms/sms-reseller-service/dynamicSMSService/uploadDynamicMessageFile`,
  dynamicPreview: `${DOMAIN}/sms/sms-reseller-service/dynamicSMSService/getPreview`,
  dynamicCampaign: `${DOMAIN}/sms/sms-reseller-service/dynamicSMSService/sendDynamicSMS`,
  groupCampaign: `${DOMAIN}/sms/sms-reseller-service/groupSMSService/sendGroupSMS`,

  //Reportu
  clickerAnalytics : `${DOMAIN}/sms/sms-reseller-service/wt/reportService/clickerAnalytics`,
  clickerreportAnalytii: `${DOMAIN}/sms/sms-reseller-service/wt/reportService/userClickerSummaryReport`,
  // clickerreportAnalytii: `${DOMAIN}/file-uploader/reportService/detailedAnalyticsReport`,
  profile: `${DOMAIN}/auth/users/userProfile/userProfileDetails`,
  updatedPassword: `${DOMAIN}/sms/sms-reseller-service/wt/userProfile/updatedPassword`,
  url: `${BASE_URL}`,
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
